import { Injectable } from '@angular/core';
import { DatePipe, formatDate } from '@angular/common';
import { BehaviorSubject, firstValueFrom, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { AlertConfirmService } from './alert-confirm.service';

import ddDataZ from '../json/dropdowns.json';
import menuData from '../json/menu-items.json';
import cityData from '../json/india-states-districts.json';
import settings from '../json/settings.json';

@Injectable({ providedIn: 'root' })

export class DataService {
  mySecretKey = "SynergyERP-2026";
  pgType = '';
  optMaxWin = false;
  headers: any = null;
  onBoarding = false;
  my_modules: any = [];

  settings: any = settings;
  cityDataDD: any = cityData;

  menuData = menuData;
  mdata4load = ddDataZ.mdata4load;
  targetNames = [
    'institute_types', 'inquiry_status', 'payment_modes', 'document_types',
    'user_roles', 'sources', 'designations', 'departments', 
    'lead_status', 'classes', 'sections', 'streams', 'inquiry_mode', 
    'fin_period', 'eligibility_status', 'boards', 'categories', 'subjects', 'religions', 'inv_item_cat',
    'fee_heads', 'class_rooms'
  ];

  ddData: any = null;

  user_roles = this.ddData?.user_roles;
  sources = this.ddData?.sources;
  designations = this.ddData?.designations;
  departments = this.ddData?.departments;
  institute_types = this.ddData?.institute_types;
  inquiry_status = this.ddData?.inquiry_status;
  lead_status = this.ddData?.lead_status;
  classes = this.ddData?.classes;
  sections = this.ddData?.sections;
  streams = this.ddData?.streams;
  inquiry_mode = this.ddData?.inquiry_mode;
  payment_modes = this.ddData?.payment_modes;
  document_types = this.ddData?.document_types;
  fin_period = this.ddData?.fin_period;
  eligibility_status = this.ddData?.eligibility_status;
  boards = this.ddData?.boards;
  categories = this.ddData?.categories;
  subjects = this.ddData?.subjects;
  religions = this.ddData?.religions;
  inv_item_cat = this.ddData?.inv_item_cat;
  fee_heads = this.ddData?.fee_heads;
  class_rooms = this.ddData?.class_rooms;

  erp_mgr = settings.erp_mgr;
  
  // Hold the initial or updated state
  private valueSource: any = new BehaviorSubject<any>(null);
  
  // Expose the state as an observable for components to listen to
  outerAction: any = this.valueSource.asObservable();

  constructor(
    public auth: AuthService, 
    private alertService: AlertConfirmService
  ) {
      //
  }

  async getDDData() {
    try {
      // 1. Strictly await the promise and get the result directly
      const res: any = await this.getAllRecords('mdata');

      if (res && res.length) {
        this.ddData = [...res];
        // const targetNames = res.map((item: any) => item.data_for);
        // const targetNames = [...new Set(this.ddData.map((item: any) => item.data_for))];
        const ddThis: any = this;

        // 2. Use a standard for...of loop instead of .forEach
        if(this.targetNames && this.targetNames.length) {
          for (const name of this.targetNames) {
            // Filter the matching items
            const retVal = this.ddData.filter((item: any) => item.data_for === name);

            if (retVal && retVal.length) {
              // 3. Map the array cleanly instead of using a manual for-loop with push
              ddThis[name] = retVal.map((item: any) => ({
                code: item.md_code,
                name: item.md_name
              }));
            }
          }
        }
      }
    } catch (error) {
      console.error("Error fetching DD data:", error);
    }
  }

  // Method to change the state
  updateOuterAction(newValue: any) {
    this.valueSource.next(newValue);
  }

  getDist(state: string) {
    const distX: any = this.cityDataDD.filter((obj: any)=>{
      return obj.state==state;
    });

    if(distX) {
      return distX[0].districts;
    }
  }

  getClassName(code: string) {
    if(!code) return;
    const result = this.classes.find((ddd: any) => ddd.code === code);
    return result?.name;
  }

  getStreamName(code: string) {
    if(!code) return;
    const result = this.streams.find((ddd: any) => ddd.code === code);
    return result?.name;
  }

  getInqStatus(code: string) {
    if(!code) return;
    const result = this.inquiry_status.find((ddd: any) => ddd.code === code);
    return result?.name;
  }

  getLeatStatus(code: string) {
    if(!code) return;
    const result = this.lead_status.find((ddd: any) => ddd.code === code);
    return result?.name;
  }
  
  getInqMode(code: string) {
    if(!code) return;
    const result = this.inquiry_mode.find((ddd: any) => ddd.code === code);
    return result?.name;
  }

  getInstituteType(code: string) {
    if(!code) return;
    const result = this.institute_types.find((ddd: any) => ddd.code === code);
    return result?.name;
  }
  getSourceName(code: string) {
    if(!code) return;
    const result = this.sources.find((ddd: any) => ddd.code === code);
    return result?.name;
  }
  getSubjectName(code: string) {
    if(!code) return;
    const result = this.subjects.find((ddd: any) => ddd.code === code);
    return result?.name;
  }
  getDesiName(code: string) {
    if(!code) return;
    const result = this.designations.find((ddd: any) => ddd.code === code);
    return result?.name;
  }
  getRoleName(code: string) {
    if(!code) return;
    const result = this.designations.find((ddd: any) => ddd.code === code);
    return result?.name;
  }

  getDeptName(code: string) {
    if(!code) return;
    const result = this.departments.find((ddd: any) => ddd.code === code);
    return result?.name;
  }

  getRoomName(code: string) {
    if(!code) return;
    const result = this.class_rooms.find((ddd: any) => ddd.code === code);
    return result?.name;
  }

  getInvCat(code: string) {
    if(!code) return;
    const result = this.inv_item_cat.find((ddd: any) => ddd.code === code);
    return result?.name;
  }

  getUserRole(rCode: any) {
    return this.user_roles.find((obj: any) => {
      return obj.code == rCode;
    });
  }

  getMenuData(node: any) {
    const menuDataZ: any = menuData;
    return menuDataZ[node];
  }

  getMainMenuItem(mmid: any) {
    return menuData.mainMenu.find((obj: any) => {
      return obj.id == mmid;
    });
  }

  getMenuTitle() {
    let retVal: any = menuData.mainMenu.find((obj: any) => {
      return obj.optClick == this.pgType;
    });

    return (retVal && retVal.title);
  }

  getMenuIcon() {
    let retVal: any = menuData.mainMenu.find((obj: any) => {
      return obj.optClick == this.pgType;
    });

    return (retVal && retVal.icon);
  }

  dmy2ymd(dmyDate: any) {
    if (!dmyDate) return;
    dmyDate = dmyDate.substr(0,10);
    const [year, month, day] = dmyDate.split('-');
    return `${year}/${month}/${day}`;
  }

  ymd2dmy(dymdDate: any): any {
    if (!dymdDate) return;
    dymdDate = dymdDate.substr(0,10);
    const [year, month, day] = dymdDate.split('-');
    return `${day}/${month}/${year}`;
  }

  getDaysDiff(d1: Date, d2: Date): number {
    const msPerDay = 1000 * 60 * 60 * 24;
    const msDiff = d2.getTime() - d1.getTime();
    return Math.trunc(msDiff / msPerDay)+1;
  }

  getFutureDate(inputDate: Date | string | number, daysToAdd: number): any {
    const date = new Date(inputDate); 
    date.setDate(date.getDate() + daysToAdd); 
    // return formatDate(date, 'dd-MM-yyyy');
    return date;
  }

  getPackageName(pcode: string) {
    // const pcode: string = this.formData.package.pkg_code;
    let pname: string = '';

    if (pcode == "p1") pname = "Basic";
    if (pcode == "p2") pname = "Premium";
    if (pcode == "p3") pname = "Gold";
    if (pcode == "p4") pname = "Self Customized";

    return pname;
  }

  getUUID(length: number, allowedChars: string): string {
    let result = '';
    const poolLength = allowedChars.length;

    // Cryptographically secure random array matching the requested length
    const randomValues = new Uint32Array(length);
    crypto.getRandomValues(randomValues);

    for (let i = 0; i < length; i++) {
      // Map the random value to an index in your character pool
      const randomIndex = randomValues[i] % poolLength;
      result += allowedChars.charAt(randomIndex);
    }

    return result;
  }

  getInitName(name: string) {
    return name
    .split(' ')                  // 1. Split the name into an array of words
    .filter(word => word !== '') // 2. Remove extra spaces if any
    .map(word => word[0])        // 3. Extract the first letter of each word
    .join('')                    // 4. Join the letters back into a single string
    .toUpperCase();
  }

  // Encrypts text using a dynamic XOR key and turns it into readable hex characters
  myEncrypt(text: string) {
    if(!text) return;

    const key: string = this.mySecretKey;
    let result = "";
    for (let i = 0; i < text.length; i++) {
      // XOR the char code of the text with the char code of the repeating key
      const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      // Convert to hex and pad with a leading zero if it's a single digit
      result += charCode.toString(16).padStart(2, '0');
    }

    return result;
  }

  // Decrypts the hex string back to the original text using the same key
  myDecrypt(hexText: string) {
    if(!hexText) return;

    const key: string = this.mySecretKey;
    let result = "";
    for (let i = 0; i < hexText?.length; i += 2) {
      // Grab every two hex characters and convert them back to a number
      const hexPart = hexText?.substring(i, i + 2);
      const charCode = parseInt(hexPart, 16) ^ key.charCodeAt((i / 2) % key.length);
      // Convert the resulting number back to a character
      result += String.fromCharCode(charCode);
    }
    return result;
  }

  generateRandomKey(segmentLength = 4, totalSegments = 4) {
    // Excluded confusing characters (O, 0, I, 1) for readability
    const charset = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let segments = [];

    for (let i = 0; i < totalSegments; i++) {
        let currentSegment = '';
        for (let j = 0; j < segmentLength; j++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            currentSegment += charset[randomIndex];
        }
        segments.push(currentSegment);
    }

    return segments.join('-');
  }

  // Helper to convert an ArrayBuffer to a Hexadecimal string
  bufToHex = (buf: any) => Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');

  // Helper to convert a Hexadecimal string back to an ArrayBuffer
  hexToBuf = (hex: any) => new Uint8Array(hex.match(/.{1,2}/g).map((byte: any) => parseInt(byte, 16))).buffer;

  async encryptString(text: string, key: any) {
    const encodedText = new TextEncoder().encode(text);
    
    // Generate a fresh, random 12-byte initialization vector (IV) every time
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    
    const ciphertextBuffer = await window.crypto.subtle.encrypt(
        { name: "AES-GCM", iv: iv },
        key, encodedText
    );

    // Combine the unique IV and the encrypted content into a single string for transport
    const combinedPayload = new Uint8Array(iv.length + ciphertextBuffer.byteLength);
    combinedPayload.set(iv, 0);
    combinedPayload.set(new Uint8Array(ciphertextBuffer), iv.length);

    return this.bufToHex(combinedPayload.buffer);
  }

  async decryptString(hexCiphertext: string, key: any) {
    const combinedBuffer = this.hexToBuf(hexCiphertext);
    const combinedArray = new Uint8Array(combinedBuffer);
    
    // Extract the 12-byte IV from the front of the payload
    const iv = combinedArray.slice(0, 12);
    const ciphertext = combinedArray.slice(12);

    const decryptedBuffer = await window.crypto.subtle.decrypt(
        { name: "AES-GCM", iv: iv },
        key, ciphertext
    );

    return new TextDecoder().decode(decryptedBuffer);
}

  // === Demonstration Execution ===
  async runRndCrypt(targetWord: string) {
    // Generate a secure, symmetric secret key
    const secretKey = await window.crypto.subtle.generateKey(
        { name: "AES-GCM", length: 256 },
        true,
        ["encrypt", "decrypt"]
    );

    // Encrypting the exact same word multiple times
    const encryptedRun1 = await this.encryptString(targetWord, secretKey);
    const encryptedRun2 = await this.encryptString(targetWord, secretKey);

    console.log("Run 1 Result:", encryptedRun1); 
    console.log("Run 2 Result:", encryptedRun2); 
    console.log("Are ciphertexts identical?", encryptedRun1 === encryptedRun2); // Returns: false

    // Decrypting both unique results yields the original token
    const decrypted1 = await this.decryptString(encryptedRun1, secretKey);
    const decrypted2 = await this.decryptString(encryptedRun2, secretKey);

    console.log("Decrypted Run 1:", decrypted1); // Returns: "HelloSecret"
    console.log("Decrypted Run 2:", decrypted2); // Returns: "HelloSecret"
  }

  async getAllRecords(base: any, opt: any = null): Promise<any> {
    try {
      // Converts the observable stream into a promise and awaits the first emission
      const res = await firstValueFrom(this.auth.requestApi(base, opt ? 'all_dataZ' : 'all_data', 0, opt));
      return res || null;
    } catch (err: any) {
      if(err?.status==401 || err?.status==403) {
        this.auth.logout();
        location.reload();
      }

      return null; // Equivalent to your error fallback
    }
  }

  async getSingleRecord(base: any, myid: any): Promise<any> {
    try {
      // Converts the observable stream into a promise and awaits the first emission
      const res = await firstValueFrom(this.auth.requestApi(base, 'get_data', myid, null));
      return res || null;
    } catch (err: any) {
      if(err?.status==401 || err?.status==403) {
        this.auth.logout();
        location.reload();
      }

      return null; // Equivalent to your error fallback
    }
  }

  enCodeUser(user: any) {
    // Encrypt the role code before setting in localstorage for safety
    for(let i=0; i<user.user_role.length; i++) {
      user.user_role[i].code = this.myEncrypt(user.user_role[i].code);
      user.user_role[i].name = this.myEncrypt(user.user_role[i].name);
    }

    user.id = this.myEncrypt(user.id.toString());
    user.is_active = this.myEncrypt(user.is_active.toString());

    return user;
  }

  deCodeUser(user: any) {
    if(user.subscribe) return user;

    for(let i=0; i<user.user_role.length; i++) {
      user.user_role[i].code = this.myDecrypt(user.user_role[i].code);
      user.user_role[i].name = this.myDecrypt(user.user_role[i].name);
    }
    user.id = this.myDecrypt(user.id);
    user.is_active = this.myDecrypt(user.is_active);

    user.id = parseInt(user.id);
    user.is_active = user.is_active=='true' ? true : false;

    return user;
  }

  str2json(badJsonString: any) {
    if(typeof badJsonString != 'string') return badJsonString;

    const first2Char = badJsonString.substr(0,2);
    const first3Char = badJsonString.substr(0,3);
    let cleanArray: any = null;

    if(first3Char=="{\"{") {
      const matches = badJsonString.match(new RegExp('}","{', "g"));
      const stringCount = matches ? matches.length : 0;
      if(stringCount > 0) {
        cleanArray = badJsonString.slice(2, -2).replace(/}","{/g, '}, {').split(', ');
      } else {
        cleanArray = badJsonString.slice(2, -2);
        const validJsonStr = cleanArray.replace(/\\"/g, '"');
        return [JSON.parse(validJsonStr)];
      }
    } else if(first2Char=="{\"") {
      cleanArray = badJsonString.replace(/}","{/g, '}, {').split(', ');
    }
    
    const parsedData = cleanArray.map((item:any) => {
      const validJsonStr = item.replace(/\\"/g, '"');
      return JSON.parse(validJsonStr);
    });

    if(parsedData) {
      return parsedData;  
    } else {
      return badJsonString;
    }
  }

  /**
   * Recursively searches a JSON object/array for a keyword.
   * Returns true if the keyword is found in any key or string/number value.
   */
  containsKeyword(data: any, keyword: any): any {
    // Clean and lower-case the keyword for case-insensitive searching
    const term = String(keyword).toLowerCase();

    // Base case: check if data is null or undefined
    if (data === null || data === undefined) return false;

    // Case 1: If it's an array, look inside each item
    if (Array.isArray(data)) {
      return data.some((item: any) => this.containsKeyword(item, term));
    }

    // Case 2: If it's an object, check keys and values recursively
    if (typeof data === 'object') {
      return Object.entries(data).some(([key, value]) => {
        // Check if the object's key contains the keyword
        if (key.toLowerCase().includes(term)) return true;
        // Drill down into the object's value
        return this.containsKeyword(value, term);
      });
    }

    // Case 3: If it's a primitive value (string, number, boolean), check if it matches
    return String(data).toLowerCase().includes(term);
  }


  addNewRecord(base: any, frmData: any, hideMsg?: boolean): Observable<any> {
    return this.auth.requestApi(base, 'create', 0, frmData).pipe(
      map((res: any) => {
        if(!hideMsg) {
          this.alertService.alert(
            'Saved!',
            'Record has been saved successfully.',
            'success'
          );
        }
        return res; // Returns the successful response to the caller
      }),
      catchError((err: any) => {
        if(!hideMsg) {
          this.alertService.alert(
            'Error!',
            'Record is not saved. ' + err?.message || err?.error?.message,
            'danger'
          );
        }
        return throwError(() => err); // Passes the error back to the caller
      })
    );
  }

  updateRecord(base: any, myid: number, frmData: any, hideMsg?: boolean): Observable<any> {
    return this.auth.requestApi(base, 'update', myid, frmData).pipe(
      map((res: any) => {
        if(!hideMsg) {
          this.alertService.alert(
            'Saved!',
            'Record has been update successfully.',
            'success'
          );
        }
        return res; // Returns the successful response to the caller
      }),
      catchError((err: any) => {
        if(!hideMsg) {
          this.alertService.alert(
            'Error!',
            'Record is not being modify. ' + err?.error?.message,
            'danger'
          );
        }
        return throwError(() => err); // Passes the error back to the caller
      })
    );
  }

  confirmDelete(): Promise<boolean> {
    return new Promise((resolve) => {
      this.alertService.confirm(
        'Delete?',
        'Are you sure you want to delete?',
        () => {
          resolve(true); // User confirmed
        },
        () => {
          resolve(false); // User cancelled
        },
        'danger'
      );
    });
  }

  deleteRecord(base: any, myid: number): Observable<any> {
    return this.auth.requestApi(base, 'delete', myid, null).pipe(
      map((res: any) => {
        this.alertService.alert(
          'Deleted!',
          'Record has been deleted successfully.',
          'success'
        );
        return res; // Returns the successful response to the caller
      }),
      catchError((err: any) => {
        this.alertService.alert(
          'Error!',
          'Could not delete record details.' + err?.error?.message,
          'danger'
        );
        return throwError(() => err); // Passes the error back to the caller
      })
    );
	}

  detectDeviceType() {
    const width = window.innerWidth;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (width <= 768 && isTouchDevice) {
      return 'Mobile';
    } else if (width <= 1024 && isTouchDevice) {
      return 'Tablet';
    } else {
      return 'Desktop';
    }
  }

  async setActivityLog(act: string, mod: string, desc: string) {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.deCodeUser(erp_rem);

      if(erp_rem.user_name != 'mwcc') {
        const nav = navigator as any;
        let entry_form = {
          user_id:      erp_rem.id,
          act_action:   act,
          act_module:   mod,
          description:  desc,
          ip_address:   erp_rem.ip_address,
          device:       this.detectDeviceType(),
          browser:      nav.userAgentData.brands[0].brand,
          cur_date:     new Date().toISOString()
        };
        
        this.addNewRecord('activity_log', entry_form, true).subscribe();
      }
    }
  }

}
